var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFirstup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 238 86.51",
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f74857;}.cls-2{fill:#301e6b;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M59.17,37.56c1.91-5.1,6.7-7.65,12.12-7.65v11.48c-3.11-.4-5.98,.24-8.45,1.91-2.47,1.67-3.67,4.39-3.67,8.21v19.05h-10.28V30.71h10.28v6.86Z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.73,46.41c5.82,1.2,13.39,3.99,13.31,12.52,0,4.07-1.51,7.25-4.62,9.49-3.03,2.15-6.86,3.27-11.4,3.27-8.21,0-13.79-3.19-16.74-9.49l8.93-5.02c1.2,3.43,3.75,5.18,7.81,5.18,3.67,0,5.5-1.12,5.5-3.43,0-2.15-3.19-3.35-7.26-4.38-5.9-1.52-13.31-3.99-13.31-12.28,0-3.91,1.44-7.02,4.31-9.25,2.95-2.31,6.54-3.43,10.84-3.43,6.46,0,12.04,3.03,15.15,8.45l-8.77,4.78c-1.27-2.71-3.43-4.07-6.38-4.07-2.63,0-4.62,1.28-4.62,3.27,0,2.15,3.19,3.35,7.25,4.38Z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.65,30.71h10.28v39.86h-10.28v-4.46c-2.47,3.75-6.46,5.58-11.88,5.58-4.38,0-7.97-1.44-10.84-4.38-2.79-2.95-4.23-6.94-4.23-12.12V30.71h10.28v23.2c0,5.34,3.11,8.21,7.89,8.21,5.34,0,8.77-3.27,8.77-9.89V30.71Z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.26,35.73c3.83,4.07,5.74,9.01,5.74,14.91s-1.91,10.92-5.74,14.99c-3.75,4.07-8.37,6.06-13.71,6.06s-9.89-1.91-12.92-5.82v20.65h-10.28V30.71h10.28v4.7c3.03-3.91,7.33-5.82,12.92-5.82s9.96,2.07,13.71,6.14Zm-15.63,26.15c3.19,0,5.82-1.04,7.89-3.11s3.19-4.86,3.19-8.13-1.04-5.98-3.19-8.05c-2.07-2.15-4.7-3.19-7.89-3.19s-5.82,1.04-7.89,3.19c-2.07,2.07-3.11,4.78-3.11,8.05s1.04,5.98,3.11,8.13c2.07,2.07,4.7,3.11,7.89,3.11Z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.5,24.8c2.53-5.39,5.18-8.04,10.57-10.57,1.19-.56,1.19-2.2,0-2.76-5.39-2.53-8.04-5.18-10.57-10.57-.56-1.19-2.2-1.19-2.76,0-2.53,5.39-5.18,8.04-10.57,10.57-1.19,.56-1.19,2.2,0,2.76,5.39,2.53,8.04,5.18,10.57,10.57,.56,1.19,2.2,1.2,2.76,0Z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.45,40.59v-9.89h-32.66v9.89h11.15v16.58c0,10.12,4.45,14.36,16.34,13.65,.94-.06,1.92-.14,2.95-.26v-9.33c-1,.05-1.93,.1-2.77,.11-4.1,.06-6.24-.6-6.24-4.18v-16.58h11.22Z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.47,23.53c-5.66-.4-8.45,1.83-8.45,6.78v.4h8.45v9.89h-8.45v29.97H5.74v-29.97H0v-9.89H5.74v-.4c0-11.24,6.3-17.38,18.73-16.66v9.89Z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.18,70.57V30.71h10.28v39.86h-10.28Z",
    className: "cls-2"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstup);
export default __webpack_public_path__ + "static/media/firstup.6883abcd7dd418adc732d43ede5a5c55.svg";
export { ForwardRef as ReactComponent };